import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromCustomerPaymentMethods from './+state/customer-payment-methods.reducer'
import { CustomerPaymentMethodsEffects } from './+state/customer-payment-methods.effects'
import { CustomerPaymentMethodsFacade } from './+state/customer-payment-methods.facade'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromCustomerPaymentMethods.CUSTOMER_PAYMENT_METHODS_FEATURE_KEY,
      fromCustomerPaymentMethods.customerPaymentMethodsReducer,
    ),
    EffectsModule.forFeature([CustomerPaymentMethodsEffects]),
  ],
  providers: [CustomerPaymentMethodsFacade],
})
export class GbDashboardCheckoutDataAccessCustomerPaymentMethodsModule {}
